import { Link } from '@tanstack/react-router';
import { ArrowLeft, Pencil } from 'lucide-react';

const PARTIES_INTERESSEES_DOC_TO = '/contexte/parties-prenantes' as const;

/** Bandeaux latéraux type maquette ISO / DashboardFlow (entrées & sorties du système). */
export function CartographyInputSidebar() {
  return (
    <aside className="flex w-[220px] shrink-0 flex-col border-slate-200/80 border-r bg-white/95 px-4 py-6 shadow-sm lg:w-[260px]">
      <Link
        to={PARTIES_INTERESSEES_DOC_TO}
        search={{ openDocumentRights: false }}
        className="group -mx-2 block rounded-xl px-2 py-1 text-left outline-none transition-colors ring-sky-500 focus-visible:ring-2"
      >
        <div className="flex items-start justify-between gap-2">
          <h2 className="font-bold text-slate-800 text-sm leading-snug transition-colors group-hover:text-sky-800">
            Besoins et attentes des parties intéressées
          </h2>
          <span
            className="shrink-0 rounded-lg p-1.5 text-sky-600 transition-colors group-hover:bg-sky-50"
            title="Ouvrir le document"
          >
            <Pencil className="h-4 w-4" aria-hidden />
          </span>
        </div>
        <p className="mt-4 text-slate-600 text-xs leading-relaxed group-hover:text-slate-700">
          Respect de la réglementation
        </p>
      </Link>
      <p className="mt-6 text-[0.65rem] text-slate-400">
        Dernière mise à jour :{' '}
        {new Date().toLocaleDateString('fr-FR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })}
      </p>
    </aside>
  );
}

export function CartographyOutputSidebar() {
  return (
    <aside className="flex w-[220px] shrink-0 flex-col items-center border-slate-200/80 border-l bg-white/95 px-4 py-8 text-center shadow-sm lg:w-[260px]">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-sky-500 text-white shadow-md">
        <ArrowLeft className="h-8 w-8" strokeWidth={2.5} aria-hidden />
      </div>
      <h2 className="font-bold text-slate-800 text-sm leading-snug">
        Satisfaction des besoins et attentes
      </h2>
      <p className="mt-3 text-slate-600 text-xs leading-relaxed">Respect de la réglementation</p>
    </aside>
  );
}
